import { defineComponent as _defineComponent } from 'vue'
import { toRefs, useContext, useRoute, watch } from '@nuxtjs/composition-api';
import type { MetaUser } from '~/core/models/MetaUser';
import { ACTIONS as AUTH_ACTIONS } from '~/store/affility/user/auth/names';

interface Props {
    user: MetaUser;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileContent',
  props: {
    user: null
  },
  emits: ['close', 'contract-addresses', 'languages'],
  setup(__props: any, { emit: $emit }) {

const props = __props as {
    user: MetaUser;
};




const {
    user,
} = toRefs(props);

const {
    store,
} = useContext();

const logout = store.dispatch.bind(null, `affility/user/auth/${AUTH_ACTIONS.LOG_OUT}`);

const route = useRoute();

watch(route, (newVal, oldVal) => {
    if (newVal.fullPath !== oldVal.fullPath &&
        oldVal.fullPath + '#' !== newVal.fullPath &&
        newVal.fullPath + '#' !== oldVal.fullPath
    ) {
        $emit('close');
    }
});


return { __sfc: true,$emit, props, user, store, logout, route }
}

})